import Vue from 'vue';
// Vue.config.devtools = true;

// Smoothscroll polyfill
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import {
    setupValidation
} from './validation';

// Setup vee validatequ
setupValidation(Vue);

// Import all components
import ApplicationForm from './../../components/form/application-form';
import BankAccount from './../../components/form/bank-account';
import DigiAddress from './../../components/form/digi-address';
import DigiAmountTerm from './../../components/form/digi-amount-term';
import DigiAmountTermInfo from './../../components/form/digi-amount-term-info';
import DigiCurrency from './../../components/form/digi-currency';
import DigiDate from './../../components/form/digi-date';
import DigiInput from './../../components/form/digi-input';
import DigiSelect from './../../components/form/digi-select';
import DigiSortCode from './../../components/form/digi-sortcode';
import DigiSubmitButton from './../../components/form/digi-submit-button';
import Email from './../../components/form/email';
import EmploymentStatus from './../../components/form/employment-status';
import FancySelect from './../../components/form/fancyselect';
import DigiCheckbox from './../../components/form/digi-multi-checkbox';
import FormHeaderMain from './../../components/form/headers/main';
import FormHeaderQuickCheck from './../../components/form/headers/quickcheck';
import FormHeaderRemarketing from './../../components/form/headers/remarketing';
import FormHeaderReturnCustomer from './../../components/form/headers/return-customer';
import Income from './../../components/form/income';
import LoanPurpose from './../../components/form/loan-purpose';
import Outgoings from './../../components/form/outgoings';
import QuickcheckSummary from './../../components/form/quickcheck-summary';
import VueCurrencyInput from 'vue-currency-input';
import PayDates from './../../components/form/pay-dates';
import MobileNumberInput from './../../components/form/mobile-number-input';
import QuoteBoost from './../../components/form/quote-boost';
import CommunicationPreferences from './../../components/form/communication-preferences';
import TestCommunicationPreferences from './../../components/form/test-communication-preferences';
import Signpost from './../../components/form/signpost';
import Faq from './../../components/form/faq';

Vue.component(
    'quickform-check',
    require('./../../components/form/quickform-check.vue').default
);

const currencyOptions = {
    /* see config reference */
    globalOptions: {
        currency: 'GBP',
        locale: 'en',
        precision: 0
    }
}

Vue.use(VueCurrencyInput, currencyOptions);

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('currency', function (value) {
    if (!value) return ''
    value = value.toString()
    return '£' + formatCurrency(value);
});

Vue.directive('numberOnly', {
    bind: function (element, binding) {
        if (binding.value) {
            element.inputHandler = function (event) {
                if (element.value) {
                    element.value = element.value.replace(/\D+/, '');
                }
            };
            element.keyDownHandler = function (event) {
                if (!(/[0-9]|Arrow|Tab|Enter|Backspace|Delete/i.test(event.key)) && !event.metaKey) {
                    event.preventDefault();
                }
            };
            element.addEventListener('input', element.inputHandler);
            element.addEventListener('keydown', element.keyDownHandler);
        }
    },
    unbind: function (element, binding) {
        element.removeEventListener('input', element.inputHandler);
        element.removeEventListener('keydown', element.keyDownHandler);
    }
});

Vue.directive('scrollToOnFocus', {
    bind: function (element, binding) {
        if (binding.value) {
            element.focusHandler = function (event) {
                // scrollToElementIfRequired(element, 750);
            };
            element.addEventListener('focusin', element.focusHandler);
        }
    },
    unbind: function (element, binding) {
        element.removeEventListener('focusin', element.focusHandler);
    }
});

import ExpandTransition from './../../components/expand-transition';
import PageTransition from './../../components/page-transition';
import FadeTransition from './../../components/fade-transition';
import { formatCurrency } from './form-functions';

window.formVue = new Vue({
    el: '#apply',
    data: function () {
        return window.formData || {};
    },
    components: {
        'application-form': ApplicationForm,
        'bank-account': BankAccount,
        'communication-preferences': CommunicationPreferences,
        'test-communication-preferences': TestCommunicationPreferences,
        'digi-address': DigiAddress,
        'digi-amount-term': DigiAmountTerm,
        'digi-amount-term-info': DigiAmountTermInfo,
        'digi-currency': DigiCurrency,
        'digi-date': DigiDate,
        'digi-input': DigiInput,
        'digi-select': DigiSelect,
        'digi-multi-checkbox': DigiCheckbox,
        'digi-sortcode': DigiSortCode,
        'digi-submit-button': DigiSubmitButton,
        'email': Email,
        'employment-status': EmploymentStatus,
        'expand-transition': ExpandTransition,
        'fade-transition': FadeTransition,
        'fancy-select': FancySelect,
        'form-header-main': FormHeaderMain,
        'form-header-quickcheck': FormHeaderQuickCheck,
        'form-header-remarketing': FormHeaderRemarketing,
        'form-header-quickform': require('./../../components/form/headers/quickform').default,
        'interested-in-app': require('./../../components/form/interested-in-app.vue').default,
        'interested-in-secured-loan': require('./../../components/form/interested-in-secured-loan.vue').default,
        'form-header-return-customer': FormHeaderReturnCustomer,
        'income': Income,
        'loan-purpose': LoanPurpose,
        'mobile-number-input': MobileNumberInput,
        'outgoings': Outgoings,
        'page-transition': PageTransition,
        'pay-dates': PayDates,
        'quickcheck-summary': QuickcheckSummary,
        'quote-boost': QuoteBoost,
        'signpost': Signpost,
        'faq': Faq,
    }
});

export function getKeyboardFocusableElements(element = document) {
    return [...element.querySelectorAll(
            'a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
        )]
        .filter(el => {
            return !el.hasAttribute('disabled') && el.getAttribute('tabindex') != '-1'
        })
}

export function scrollToElementIfRequired(element, delay = 0) {
    if (element == null || element.getBoundingClientRect == null) {
        return false;
    }
    setTimeout(() => {
        const yOffset = -30;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }, delay);
}

export function faqLinkClick(questionId, signpostText) {
        var targetFaqSection = document.getElementById('form-footer-toggle');
        var targetQuestionText = $(questionId).text().trim();
        if (!targetFaqSection.classList.contains('rotate')){
            targetFaqSection.click();
        }
        //if class rotate already exists then the target faq section is already open so dont click just scroll
        if (!$(questionId).closest('.help-faq-question-text').hasClass('rotate')){
            $(questionId).trigger('click');    
        }
            // Smooth scroll to the element
        $('html, body').animate({
            scrollTop: $(questionId).offset().top -200
        }, 'slow');

        window.amplitude.faqLinkClick(signpostText, targetQuestionText);
};

document.getElementById('form-footer-toggle').addEventListener('click', function() {
    if (this.classList.contains('rotate')) {
        this.classList.remove('rotate');
    } else {
        this.classList.add('rotate');
    }
});
